import useResponsive from 'hooks/useResponsive';
import useTranslation from 'hooks/useTranslation';
import React from 'react';

import style from './index.style';
import TurnkeyCard from './TurnkeyCard';

export default function TurnkeyPlan({ plan, promoPrice }) {
  const { TRANSLATIONS } = useTranslation();
  const { isMobile, isTablet, isLaptop } = useResponsive();
  const isSmallDevice = isMobile || isTablet || isLaptop;
  return (
    <div className="plans-section d-f jc-c ai-c fd-c">
      <div className="title-plans">
        <h4>{TRANSLATIONS.pricing.turnkey.title}</h4>
        <p>{TRANSLATIONS.pricing.turnkey.paragraph}</p>
      </div>
      {/*
        <div className={'limited-time-offer'}>
        {promoPrice
          ? TRANSLATIONS.pricing.discount.limitedTimeOffer
          : TRANSLATIONS.pricing.discount.yearly}
      </div>
         */}
      <div className={`plans ${isSmallDevice && 'fw-w'}`}>
        {plan
          .sort((a) => {
            if (a.planCode === 'dropeasysite') return -1;
            if (a.planCode === 'dropeasy') return -1;
            return 0;
          })
          .map((plan) => (
            <TurnkeyCard
              plan={plan}
              key={plan?.planId}
              promoPrice={promoPrice}
            />
          ))}
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
